import request from '@/utils/http'

// 首页kv列表
export function getKvvList(query) {
  return request({
    url: '/system/kv/listForPc',
    method: 'get',
    params: query
  })
}

// 首页矩阵
export function getMatrixList(query) {
  return request({
    url: '/system/matrix/listForPc',
    method: 'get',
    params: query
  })
}
// 新闻列表
export function getNewsList(query) {
  return request({
    url: '/portal/news/list',
    method: 'get',
    params: query

  })
}

export function getNewsListHtml(query) {
  return request({
    url: '/portal/news/list/html',
    method: 'get',
    params: query

  })
}
// 新闻详情
export function getNewsDetail(id) {
  return request({
    url: `/portal/news/${id}`,
    method: 'get',
  })
}
// 二级分类列表
export function listSecond(query) {
  return request({
    url: '/system/second/list',
    method: 'get',
    params: query
  })
}
// 根据id获取二级分类信息
export function productList(query) {
  return request({
    url: 'system/product/list',
    method: 'get',
    params: query
  })
}



